<mat-drawer-container class="example-container" [hasBackdrop]="true">
  <mat-drawer class="app-drawer" #drawer>
    <aside>
      @if (isStaging()) {
      <span class="env-badge">STAGING-DEMO</span>
      }
      @if (this.game.game) {
      <button mat-flat-button data-testid="openLineup" (click)="openLineupSheet()">
        {{ 'components.topSection.editLineup' | transloco }}
      </button>
      <button mat-flat-button data-testid="openStats" (click)="game.openStats()">{{ 'components.topSection.showStats' |
        transloco }}</button>
      <button mat-flat-button data-testid="openStats" (click)="openV1GamePlayList()">V1 Edit Play</button>
      <mat-divider></mat-divider>
      }

      <button mat-flat-button data-testid="logout" (click)="logout()">{{ 'menu.logout' | transloco }}</button>

      <button mat-flat-button data-testid="switchLanguage" (click)="languageService.switchLanguage()">{{
        'menu.switchLanguage' | transloco }}</button>

      <a mat-flat-button data-testid="trainingLink" href="https://drive.google.com/file/d/1RAy2ZjKY7umsOylX1ett4w6Xj9nt8qDs/view?usp=sharing"
        target="_blank" rel="noopener noreferrer">{{ 'menu.training' | transloco }}</a>


      <div style="flex: 1;"></div>

      <mat-divider></mat-divider>
      <section class="tech-support">
        <div>{{ 'menu.soutientTechnique' | transloco }}</div>
        <!--      <button mat-flat-button (click)="loadLocalGame()">{{ 'menu.loadGame' | transloco }}</button>-->
        <!--      <button mat-flat-button (click)="saveGame()">{{ 'menu.saveGame' | transloco }}</button>-->
        <!--      <button mat-flat-button-->
        <!--              (click)="game.requestGameData()"-->
        <!--              [disabled]="!game?.game?.id">Exporter les données</button>-->
        <!--      <mat-divider></mat-divider>-->
        <!--      <button mat-flat-button (click)="importFakeData()">{{ 'menu.importFakeData' | transloco }}</button>-->
        <!--      <mat-divider></mat-divider>-->
        <!--      <button mat-flat-button (click)="game.debug()">{{ 'menu.debug' | transloco }}</button>-->
        <button mat-flat-button data-testid="dump" (click)="game.dump()">{{ 'menu.dump' | transloco }}</button>
      </section>

    </aside>
  </mat-drawer>
  <mat-drawer-content>
    <header role="banner" [ngClass]="{ 'staging-header': isStaging }">
      <button mat-icon-button data-testid="toggleMenu" aria-label="Toggle Menu" (click)="drawer.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <img height="50" alt="{{ 'header.title' | transloco }} Logo" src="assets/icons/StatsFootball.png" />
      <h1>
        <span class="version">({{ AppVersion }})</span>
        @if (isStaging()) {
        <span class="env-badge">STAGING-DEMO</span>
        }
      </h1>

      @if (this.game.game) {
      <button class="toolbar-button" data-testid="home" (click)="goHome()">{{ 'header.home' | transloco }}</button>
      }

      <span class="syncIdenticator">
        @if (game.onLine && this.game.game) {
        <span>
          @if (game.syncStatus === 'syncked') {
          <mat-icon aria-hidden="false" aria-label="Sync done" fontIcon="cloud_done"></mat-icon>
          }
          @if (game.syncStatus === 'syncking') {
          <mat-icon aria-hidden="false" class="syncking" aria-label="Sync" fontIcon="flip_camera_android"></mat-icon>
          }
          @if (game.syncStatus === 'error') {
          <mat-icon aria-hidden="false" class="synckingError" aria-label="Sync Issue"
            fontIcon="sync_problem"></mat-icon>
          }
        </span>
        }
        @if (!game.onLine) {
        <mat-icon aria-hidden="false" aria-label="Offline" fontIcon="cloud_off"></mat-icon>
        }
      </span>
    </header>
    <div class="content show-desktop" role="main">
      <router-outlet></router-outlet>
    </div>
    <div class="show-mobile">
      <p>{{ 'app.mobileWarning' | transloco }}</p>
    </div>
  </mat-drawer-content>
</mat-drawer-container>